import { useAuth } from "../context/AuthContext";
import { toast } from "sonner";

// Compact control letting a user pick + save their default date-range view
// (latest month vs. all time). Applied on load by pages with a Time Period filter.
export default function DefaultViewSelect() {
  const { user, savePrefs } = useAuth();
  const val = user?.preferences?.default_period_range || "";
  const onChange = async (e) => {
    const v = e.target.value;
    if (!v) return;
    try {
      await savePrefs({ default_period_range: v });
      toast.success(`Default view saved — ${v === "all" ? "All time" : "Latest month"}`);
    } catch {
      toast.error("Could not save your preference");
    }
  };
  return (
    <label className="flex items-center gap-1.5 text-[11px] text-brand-tertiary" data-testid="default-view-select" title="Your saved default date range across the app">
      <span className="uppercase tracking-[0.12em]">My default</span>
      <select value={val} onChange={onChange} data-testid="default-view-input"
        className="rounded-md border border-brand-border bg-brand-page px-2 py-1 text-[12px] text-brand-ink outline-none focus:border-brand-primary">
        <option value="" disabled>Choose…</option>
        <option value="latest">Latest month</option>
        <option value="all">All time</option>
      </select>
    </label>
  );
}
